import { useSsoCallback } from "../../hooks/useSsoCallback";
import { useAuth } from "../../hooks/useAuth";

/**
 * Runs useSsoCallback() once on mount and, while an SSO sign-in is being
 * verified (AuthContext.signingIn), covers the app with a "Signing you in…"
 * card until the session and the dashboard's first data are ready. The
 * routes keep rendering underneath so the dashboard can fetch meanwhile.
 * Must be rendered inside AuthProvider (it calls useAuth internally).
 */
function SsoCallbackHandler() {
  useSsoCallback();
  const { signingIn } = useAuth();

  if (!signingIn) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-page px-4 py-10">
      <div
        role="status"
        aria-live="polite"
        aria-busy="true"
        className="mx-auto flex w-full max-w-md flex-col items-center gap-4 rounded-lg border border-border bg-surface-raised p-8 shadow-sm"
      >
        <div
          aria-hidden="true"
          className="h-10 w-10 animate-spin rounded-full border-2 border-border border-t-accent"
        />
        <p className="text-sm font-medium text-text-primary">Signing you in…</p>
      </div>
    </div>
  );
}

SsoCallbackHandler.propTypes = {};

export default SsoCallbackHandler;
